var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74805 26.2512H8.43555L22.2605 12.4262L17.573 7.73867L3.74805 21.5637V26.2512ZM6.24805 22.6012L17.573 11.2762L18.723 12.4262L7.39805 23.7512H6.24805V22.6012Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9605 4.11367C22.473 3.62617 21.6855 3.62617 21.198 4.11367L18.9105 6.40117L23.598 11.0887L25.8855 8.80117C26.373 8.31367 26.373 7.52617 25.8855 7.03867L22.9605 4.11367Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.68bcf8af17741a3c174259b189170116.svg";
export { ForwardRef as ReactComponent };